import styled from 'styled-components/macro';

export const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  margin-top: 60px;
`;

export const MainText = styled('h1')`
  margin: 0 0 20px 0;
  font-size: 40px;
  font-weight: 700;
  line-height: 54px;
  color: #ffffff;
`;

export const SubText = styled('h2')`
  margin: 0 0 17px 0;
  color: #ffffff;
  font-size: 24px;
  font-weight: 400;
  line-height: 34px;
`;

export const Button = styled('a')<any>`
  margin: 0 0 34px 0;
  color: #0bd6a7;
  background: #ffffff;
  height: 50px;
  width: 232px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border: 1px solid #0bd6a7;
  border-radius: 0;

  svg {
    margin-bottom: ${({ marginBottom }): string =>
      marginBottom ? marginBottom : '5px'};
    path {
      fill: #0bd6a7;
    }
  }
`;

export const AndroidText = styled('p')`
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  color: #ffffff;
  margin: 0;

  svg {
    margin-bottom: -2px;
  }
`;

export const Link = styled('span')`
  border-bottom: 2px solid #ffffff;
  padding-bottom: 2px;
  cursor: pointer;

  &: hover {
    border-bottom: 3px solid #ffffff;
  }
`;
